import * as React from 'react';
import { Button, Balloon } from '@alifd/next';
import { useAppSelector } from '../../redux/hooks';

export default function OrderBtn(props: any) {
  const { i18n, productIsHang, isEmpty, btnLoading, moq, type, tipShow, setTipShow, baoAccountIsDisplayAssurance = true } = props;
  const skuInfo = useAppSelector(state => state.sku[type]);
  const { isSoldOut } = skuInfo;
  if (!baoAccountIsDisplayAssurance) return null;
  if (productIsHang) return null;
  if (isEmpty) return null;

  if (isSoldOut) {
    return <Button type="primary" disabled className='sold-out'>
      {i18n['rightAction.soldout']}
    </Button>
  }

  return (
    <Balloon
      trigger={<div className="order-button">
        <Button type="primary" loading={btnLoading} htmlType="submit" size="medium" data-domdot="id:3330"
          data-dot="d_type=place_order&cid=3330&product_desc=wholesale"
          data-spm-click="gostr=/sc;locaid=d1000">
          {i18n['rightAction.so']}
        </Button>
      </div>}
      align="t"
      className="tip-show"
      alignEdge
      visible={tipShow}
      onClose={() => setTipShow(false)}
      triggerType="hover"
      style={{
        width: 300
      }}
    >
      {i18n['undue_tpl_helpers.strongWarningText1']} {moq} {i18n['undue_tpl_helpers.strongWarningText2']}
    </Balloon>
  )
}
